module.exports = "https://health.dajiuxing.com.cn/img/assets/img/guide.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2Fimg%2Fguide.png
// module id = dPRF
// module chunks = 93